// AddProductForm.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import { API_BASE_URL } from "../../config";
import SalePOPUP from "./SalePOPUP";
import CreditLocalPOPUP from "./CreditLocalPOPUP";
import DepositPOPUP from "./DepositPOPUP";
import ExpensePOPUP from "./ExpensePOPUP";
import CardPOPUP from "./CardPOPUP";
import BankEntryPOPUP from "./BankEntryPOPUP";
import CustomOutsidePOPUP from "./CustomOutsidePOPUP";
import CustomInsidePOPUP from "./CustomInsidePOPUP";

const AddProductForm = ({
  credentialsfilter,
  product,
  setProduct,
  isLoggedIn,
  setFilterUpdated,
  savedData,
  Loancustomerssuggestions,
  banksavedData,
  expineseData,
  previous_day_total,
  bankStatement,
  quickAdds,
}) => {
  const navigate = useNavigate(); // Call useNavigate to get navigate function
  const { logout } = useAuth();
  const [isRole, setIsRole] = useState("false");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  //console.log('productproductproduct ',product);
  //console.log('setProductsetProductsetProductsetProduct ',setProduct);

  const [fields, setFields] = useState(() => {
    const savedFields = localStorage.getItem("fields");
    return savedFields ? JSON.parse(savedFields) : [];
  });
  const [mineshFields, setMineshFields] = useState(() => {
    const savedMineshFields = localStorage.getItem("mineshFields");
    return savedMineshFields ? JSON.parse(savedMineshFields) : [];
  });
  const [extraFields, setExtraFields] = useState(() => {
    const savedExtraFields = localStorage.getItem("extraFields");
    return savedExtraFields ? JSON.parse(savedExtraFields) : [];
  });
  const [anotherCustomFields, setAnotherCustomFields] = useState(() => {
    const savedAnotherCustomFields = localStorage.getItem(
      "anotherCustomFields"
    );
    return savedAnotherCustomFields ? JSON.parse(savedAnotherCustomFields) : [];
  });
  const [customTrFields, setCustomTrFields] = useState(() => {
    const savedCustomTrFields = localStorage.getItem("customTrFields");
    return savedCustomTrFields ? JSON.parse(savedCustomTrFields) : [];
  });
  const [cardFields, setCardFields] = useState(() => {
    const savedCardFields = localStorage.getItem("cardFields");
    return savedCardFields ? JSON.parse(savedCardFields) : [];
  });
  const [BankDepositfields, setBankDepositfields] = useState(() => {
    const savedBankDepositfields = localStorage.getItem("BankDepositfields");
    return savedBankDepositfields ? JSON.parse(savedBankDepositfields) : [];
  });
  const [BankDepositChargefields, setBankDepositChargefields] = useState(() => {
    const savedBankDepositChargefields = localStorage.getItem(
      "BankDepositChargefields"
    );
    return savedBankDepositChargefields
      ? JSON.parse(savedBankDepositChargefields)
      : [];
  });

  // Auto-sync all sections from SQL pending rows on each fetch
  useEffect(() => {
    if (!quickAdds) return;
    // Credit
    if (Array.isArray(quickAdds.credits)) {
      const next = quickAdds.credits.map((r) => ({
        id: r.id,
        amount: r.amount || "",
        name: r.name || "",
      }));
      setFields(next);
    }
    // Deposit Amount
    if (Array.isArray(quickAdds.deposits)) {
      const next = quickAdds.deposits.map((r) => ({
        id: r.id,
        amount: r.amount || "",
        name: r.name || "",
        mode: r.mode || "Cash",
        bank_show: !!r.bank_name,
        bank_name: r.bank_name || "",
      }));
      setMineshFields(next);
    }
    // Expinese
    if (Array.isArray(quickAdds.expenses)) {
      const next = quickAdds.expenses.map((r) => ({
        id: r.id,
        amount: r.amount || "",
        name: r.name || "",
      }));
      setExtraFields(next);
    }
    // Card
    if (Array.isArray(quickAdds.cards)) {
      const next = quickAdds.cards.map((r) => ({
        id: r.id,
        amount: r.amount || "",
        name: r.name || "",
        time: r.time || "",
        mode: r.mode || "Scan",
        bank_name: r.bank_name || "",
      }));
      setCardFields(next);
    }
    // Loans split
    if (Array.isArray(quickAdds.loans)) {
      const outs = quickAdds.loans
        .filter((l) => l.type === "Outside" || l.type === "Payment Outside")
        .map((l) => ({ id: l.id, amount: l.amount || "", name: l.name || "" }));
      setCustomTrFields(outs);
      const ins = quickAdds.loans
        .filter((l) => l.type === "Inside" || l.type === "Payment Inside")
        .map((l) => ({ id: l.id, amount: l.amount || "", name: l.name || "" }));
      setAnotherCustomFields(ins);
      const banks = quickAdds.loans
        .filter((l) =>
          [
            "Cash Deposit",
            "RTGS IN",
            "RTGS OUT",
            "Charges",
            "Payment",
          ].includes(l.type)
        )
        .map((l) => ({
          id: l.id,
          amount: l.amount || "",
          bank_name: l.bank_name || "",
          name: l.name || "",
          type: l.type || "Cash Deposit",
        }));
      setBankDepositfields(banks);
    }
  }, [quickAdds]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/managerreadingsave`,
        {
          credentialsfilter,
          product,
          fields,
          mineshFields,
          extraFields,
          anotherCustomFields,
          customTrFields,
          cardFields,
          BankDepositfields,
          total_credit: getInputTotal(),
          total_deposit: getMineshTotal(),
          total_expinese: getExtraTotal(),
          total_card: getCardTotal(),
          total_outside: getCustomTotal(),
          total_inside: getAnotherCustomTotal(),
          total_bank_deposit: getBankDepositfields(),
          previous_day_total: previous_day_total,
          current_day_total: Current_day_total(),
          net_total: Net_total(),
          final_total: Final_total(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setSuccess("Item added successfully!");
      localStorage.removeItem("fields");
      localStorage.removeItem("mineshFields");
      localStorage.removeItem("extraFields");
      localStorage.removeItem("anotherCustomFields");
      localStorage.removeItem("customTrFields");
      localStorage.removeItem("cardFields");
      localStorage.removeItem("BankDepositfields");
      localStorage.removeItem("BankDepositChargefields");

      window.location.reload();

      // Clear form after successful submission
    } catch (error) {
      //setError('Failed to add product: ' + (error.response?.data?.message || error.message));
      //setLoading(false);
      logout();
      navigate("/"); // Use navigate to redirect
    }
  };

  useEffect(() => {
    const savedFields = localStorage.getItem("fields");
    if (savedFields) {
      setFields(JSON.parse(savedFields));
    }
    const savedMineshFields = localStorage.getItem("mineshFields");
    if (savedMineshFields) {
      setMineshFields(JSON.parse(savedMineshFields));
    }
    const savedExtraFields = localStorage.getItem("extraFields");
    if (savedExtraFields) {
      setExtraFields(JSON.parse(savedExtraFields));
    }
    const savedAnotherCustomFields = localStorage.getItem(
      "anotherCustomFields"
    );
    if (savedAnotherCustomFields) {
      setAnotherCustomFields(JSON.parse(savedAnotherCustomFields));
    }
    const savedCustomTrFields = localStorage.getItem("customTrFields");
    if (savedCustomTrFields) {
      setCustomTrFields(JSON.parse(savedCustomTrFields));
    }
    const savedCardFields = localStorage.getItem("cardFields");
    if (savedCardFields) {
      setCardFields(JSON.parse(savedCardFields));
    }
    const savedBankDepositfields = localStorage.getItem("BankDepositfields");
    if (savedBankDepositfields) {
      setBankDepositfields(JSON.parse(savedBankDepositfields));
    }
    const savedBankDepositChargefields = localStorage.getItem(
      "BankDepositChargefields"
    );
    if (savedBankDepositChargefields) {
      setBankDepositChargefields(JSON.parse(savedBankDepositChargefields));
    }

    const role = localStorage.getItem("role");
    if (role) {
      setIsRole(role);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("fields", JSON.stringify(fields));
  }, [fields]);
  useEffect(() => {
    localStorage.setItem("extraFields", JSON.stringify(extraFields));
  }, [extraFields]);
  useEffect(() => {
    localStorage.setItem(
      "anotherCustomFields",
      JSON.stringify(anotherCustomFields)
    );
  }, [anotherCustomFields]);
  useEffect(() => {
    localStorage.setItem("customTrFields", JSON.stringify(customTrFields));
  }, [customTrFields]);

  const calculateBankDepositCharges = (
    bankStatement,
    cards,
    mineshs,
    deposits
  ) => {
    let bankStatementMap = {};
    // Process bankStatement safely
    if (bankStatement?.data?.length > 0) {
      bankStatementMap = bankStatement.data.reduce((acc, item) => {
        if (item.bank_name && item.total) {
          acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.total);
        }
        return acc;
      }, {});
    }

    const cardMap = cards.reduce((acc, item) => {
      if (item.bank_name && item.amount) {
        acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});

    const mineshdMap = mineshs.reduce((acc, item) => {
      if (item.bank_show && item.bank_name && item.amount) {
        acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});

    const depositMap = deposits.reduce((acc, item) => {
      if (
        item.bank_name &&
        item.amount &&
        (item.type == "Cash Deposit" || item.type == "RTGS IN")
      ) {
        acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});

    const chargesMap = deposits.reduce((acc, item) => {
      if (
        item.bank_name &&
        item.amount &&
        (item.type == "RTGS OUT" ||
          item.type == "Charges" ||
          item.type == "Payment")
      ) {
        acc[item.bank_name] = (acc[item.bank_name] || 0) + Number(item.amount);
      }
      return acc;
    }, {});

    const allBanks = new Set([
      ...Object.keys(bankStatementMap),
      ...Object.keys(cardMap),
      ...Object.keys(mineshdMap),
      ...Object.keys(depositMap),
      ...Object.keys(chargesMap),
    ]);

    let all_bank_total_deposite = 0;
    let all_bank_total_charges = 0;

    const combined = Array.from(allBanks).map((bank) => {
      const deposite =
        (cardMap[bank] || 0) +
        (mineshdMap[bank] || 0) +
        (depositMap[bank] || 0);

      const charges = chargesMap[bank] || 0;
      const total = bankStatementMap[bank] || 0;

      all_bank_total_deposite += deposite;
      all_bank_total_charges += charges;

      return {
        bank_name: bank,
        deposite,
        charges,
        total,
        bank_total: deposite - charges,
      };
    });

    const all_bank_bank_total =
      all_bank_total_deposite - all_bank_total_charges;

    return {
      data: combined,
      all_bank_total_deposite,
      all_bank_total_charges,
      all_bank_bank_total,
    };
  };

  useEffect(() => {
    // Save individual fields
    localStorage.setItem("cardFields", JSON.stringify(cardFields));
    localStorage.setItem("mineshFields", JSON.stringify(mineshFields));
    localStorage.setItem(
      "BankDepositfields",
      JSON.stringify(BankDepositfields)
    );

    // Recalculate and store combined data
    const updated = calculateBankDepositCharges(
      bankStatement,
      cardFields,
      mineshFields,
      BankDepositfields
    );
    setBankDepositChargefields(updated);
    localStorage.setItem("BankDepositChargefields", JSON.stringify(updated));
  }, [bankStatement, cardFields, mineshFields, BankDepositfields]);

  const getInputTotal = () => {
    return fields.reduce(
      (total, field) =>
        (parseFloat(total) || 0) + (parseFloat(field.amount) || 0),
      0
    );
  };

  const getMineshTotal = () => {
    return mineshFields.reduce(
      (total, field) =>
        field.mode === "Cash"
          ? total + (Math.abs(parseFloat(field.amount)) || 0)
          : total,
      0
    );
  };

  const getCardTotal = () => {
    return cardFields.reduce(
      (total, field) =>
        (parseFloat(total) || 0) + (parseFloat(field.amount) || 0),
      0
    );
  };

  const getFinalTotal = () => {
    return (
      -(parseFloat(getAnotherCustomTotal()) || 0) +
      (parseFloat(getExtraTotal()) || 0) -
      (parseFloat(getMineshTotal()) || 0) +
      (parseFloat(getInputTotal()) || 0) +
      (parseFloat(getCardTotal()) || 0) +
      (parseFloat(getCustomTotal()) || 0) +
      (parseFloat(getBankDepositfields()) || 0)
    );
  };

  const Current_day_total = () => {
    if (product.grandTotal) {
      return (
        (parseFloat(product.grandTotal) || 0) -
        (parseFloat(getFinalTotal()) || 0)
      );
    } else {
      return getFinalTotal();
    }
  };

  // const Net_total = () => {
  //   if (BankDepositChargefields.all_bank_bank_total) {
  //     return (
  //       (parseFloat(previous_day_total) || 0) +
  //       (parseFloat(Current_day_total()) || 0)
  //     );
  //   } else {
  //     return Current_day_total();
  //   }
  // };

  const Net_total = () => {
    if (previous_day_total) {
      return (
        (parseFloat(previous_day_total) || 0) +
        (parseFloat(Current_day_total()) || 0)
      );
    } else {
      return Current_day_total();
    }
  };

  const Final_total = () => {
    return (
      (parseFloat(BankDepositChargefields.all_bank_bank_total) || 0) +
      (parseFloat(Net_total()) || 0)
    );
  };

  const getExtraTotal = () => {
    return extraFields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };

  const getCustomTotal = () => {
    return customTrFields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };

  const getAnotherCustomTotal = () => {
    return anotherCustomFields.reduce(
      (total, field) => total + (parseFloat(field.amount) || 0),
      0
    );
  };

  const getBankDepositfields = () => {
    return BankDepositfields.reduce((total, field) => {
      if (field.type === "Cash Deposit") {
        return total + (parseFloat(field.amount) || 0);
      }
      return total;
    }, 0);
  };

  // Add new input row for adding
  const addAnotherCustomField = () => {
    setAnotherCustomFields([...anotherCustomFields, { name: "", amount: "" }]);
  };

  // Add new input row for adding
  const addCustomTrField = () => {
    setCustomTrFields([...customTrFields, { name: "", amount: "" }]);
  };
  // Add new input row for adding
  const addField = () => {
    setFields([...fields, { amount: "", name: "" }]);
  };

  // Add new input row for minesh (subtracting)
  const addMineshField = () => {
    setMineshFields([
      ...mineshFields,
      { amount: "", name: "", mode: "Cash", bank_show: false, bank_name: "" },
    ]);
  };

  const addExtraField = () => {
    setExtraFields([...extraFields, { amount: "", name: "" }]);
  };

  const addCardField = () => {
    setCardFields([
      ...cardFields,
      { amount: "", name: "", time: "", mode: "Scan", bank_name: "" },
    ]);
  };

  const addBankDepositfields = () => {
    setBankDepositfields([
      ...BankDepositfields,
      { amount: "", bank_name: "", name: "", type: "Cash Deposit" },
    ]);
  };
  // Function to remove a field from a given list by index
  const removeField = (index, list, setList) => {
    setList(list.filter((_, i) => i !== index));
  };

  // Remove from SQL first (if item has id), then from local state
  const removeServerField = async (category, id) => {
    if (!id) return;
    try {
      const token =
        (credentialsfilter && credentialsfilter.token) ||
        localStorage.getItem("authToken");
      await axios.post(
        `${API_BASE_URL}/api/quickremove`,
        { token, category, id },
        { headers: { "Content-Type": "application/json" } }
      );
    } catch (e) {
      // ignore network/db error and still remove locally
    }
  };

  const removeCredit = async (index) => {
    const item = fields[index];
    if (item && item.id) {
      await removeServerField("credit", item.id);
    }
    removeField(index, fields, setFields);
  };

  const removeDeposit = async (index) => {
    const item = mineshFields[index];
    if (item && item.id) {
      await removeServerField("deposit", item.id);
    }
    removeField(index, mineshFields, setMineshFields);
  };

  const removeExpense = async (index) => {
    const item = extraFields[index];
    if (item && item.id) {
      await removeServerField("expense", item.id);
    }
    removeField(index, extraFields, setExtraFields);
  };

  const removeCard = async (index) => {
    const item = cardFields[index];
    if (item && item.id) {
      await removeServerField("card", item.id);
    }
    removeField(index, cardFields, setCardFields);
  };

  const removeInside = async (index) => {
    const item = anotherCustomFields[index];
    if (item && item.id) {
      await removeServerField("loan", item.id);
    }
    removeField(index, anotherCustomFields, setAnotherCustomFields);
  };

  const removeBankEntry = async (index) => {
    const item = BankDepositfields[index];
    if (item && item.id) {
      await removeServerField("loan", item.id);
    }
    removeField(index, BankDepositfields, setBankDepositfields);
  };

  const removeOutside = async (index) => {
    const item = customTrFields[index];
    if (item && item.id) {
      await removeServerField("loan", item.id);
    }
    removeField(index, customTrFields, setCustomTrFields);
  };

  const [stock, setStock] = useState(null);

  // Fetch final stock from Laravel API
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/final-stock`)
      .then((res) => {
        // Use this if your API returns the values directly
        // { status: true, total_production: ..., total_sales: ..., final_stock: ... }
        if (res.data.status) {
          setStock(res.data);
        } else {
          setError("Invalid response from server");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error fetching final stock");
        setLoading(false);
      });
  }, []);

  return (
    <>
      {/* <form
        onSubmit={isLoggedIn ? handleSubmit : undefined}
        action="javascript:void(0);"
      > */}{" "}
      <div className="mt-4 ">
        {loading && <p>Loading stock...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {stock && (
          <div className="stock-container">
            <div className="row g-3">
              {/* Oil Stock */}
              <div className="col-4 col-md-4 col-lg-4">
                <div
                  className="card h-100 border-0 shadow-sm"
                  style={{
                    background:
                      "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                    borderRadius: "8px",
                  }}
                >
                  <div className="card-body p-2 p-md-3 text-center">
                    <div
                      className="mb-1"
                      style={{ fontSize: "1.2rem", color: "#0d47a1" }}
                    >
                      <i className="bi bi-droplet-fill"></i>
                    </div>
                    <h6
                      className="card-title fw-bold mb-1"
                      style={{ fontSize: "0.75rem" }}
                    >
                      OIL
                    </h6>
                    <div
                      className="stock-value"
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        color: "#0d47a1",
                      }}
                    >
                      {parseFloat(stock.final_stock || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>

              {/* Cake Stock */}
              <div className="col-4 col-md-4 col-lg-4">
                <div
                  className="card h-100 border-0 shadow-sm"
                  style={{
                    background:
                      "linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%)",
                    borderRadius: "8px",
                  }}
                >
                  <div className="card-body p-2 p-md-3 text-center">
                    <div
                      className="mb-1"
                      style={{ fontSize: "1.2rem", color: "#880e4f" }}
                    >
                      <i className="bi bi-cake2"></i>
                    </div>
                    <h6
                      className="card-title fw-bold mb-1"
                      style={{ fontSize: "0.75rem" }}
                    >
                      CAKE
                    </h6>
                    <div
                      className="stock-value"
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        color: "#880e4f",
                      }}
                    >
                      {parseFloat(stock.final_cake_stock || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>

              {/* Groundnut Stock */}
              {typeof stock.final_groundnut_stock !== "undefined" && (
                <div className="col-4 col-md-4 col-lg-4">
                  <div
                    className="card h-100 border-0 shadow-sm"
                    style={{
                      background:
                        "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="card-body p-2 p-md-3 text-center">
                      <div
                        className="mb-1"
                        style={{ fontSize: "1.2rem", color: "#e65100" }}
                      >
                        <i className="bi-brightness-alt-high"></i>
                      </div>
                      <h6
                        className="card-title fw-bold mb-1"
                        style={{ fontSize: "0.75rem" }}
                      >
                        GROUNDNUT
                      </h6>
                      <div
                        className="stock-value"
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: "700",
                          color: "#e65100",
                        }}
                      >
                        {parseFloat(stock.final_groundnut_stock || 0).toFixed(
                          2
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Bottles Stock */}
              {typeof stock.total_bottle_1l !== "undefined" && (
                <>
                  {/* 1L Bottle */}
                  <div className="col-4">
                    <div
                      className="card h-100 border-0 shadow-sm"
                      style={{
                        background:
                          "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="card-body p-2 p-md-3 text-center">
                        <div
                          className="mb-1"
                          style={{ fontSize: "1.2rem", color: "#2e7d32" }}
                        >
                          <i className="bi bi-cup-straw"></i>
                        </div>
                        <h6
                          className="card-title fw-bold mb-1"
                          style={{ fontSize: "0.7rem" }}
                        >
                          1L BOTTLE
                        </h6>
                        <div
                          className="stock-value"
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            color: "#2e7d32",
                          }}
                        >
                          {stock.final_bottle_1l_stock || 0}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 5L Bottle */}
                  <div className="col-4">
                    <div
                      className="card h-100 border-0 shadow-sm"
                      style={{
                        background:
                          "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="card-body p-2 p-md-3 text-center">
                        <div
                          className="mb-1"
                          style={{ fontSize: "1.2rem", color: "#2e7d32" }}
                        >
                          <i className="bi bi-cup-straw"></i>
                        </div>
                        <h6
                          className="card-title fw-bold mb-1"
                          style={{ fontSize: "0.7rem" }}
                        >
                          5L BOTTLE
                        </h6>
                        <div
                          className="stock-value"
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            color: "#2e7d32",
                          }}
                        >
                          {stock.final_bottle_5l_stock || 0}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 15L Bottle */}
                  <div className="col-4">
                    <div
                      className="card h-100 border-0 shadow-sm"
                      style={{
                        background:
                          "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="card-body p-2 p-md-3 text-center">
                        <div
                          className="mb-1"
                          style={{ fontSize: "1.2rem", color: "#2e7d32" }}
                        >
                          <i className="bi bi-cup-straw"></i>
                        </div>
                        <h6
                          className="card-title fw-bold mb-1"
                          style={{ fontSize: "0.7rem" }}
                        >
                          15L BOTTLE
                        </h6>
                        <div
                          className="stock-value"
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            color: "#2e7d32",
                          }}
                        >
                          {stock.final_bottle_15l_stock || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="product-form total-data">
        <div className="row">
          <div className="col-12 col-md-3 bg-blue-100 rounded">
            <h5 className="font-bold">Oil Kg:- </h5>
            <label className="border p-2 rounded w-1/4 col-3">Time</label>
            <label className="border p-2 rounded w-1/4 col-2">Qty</label>
            <label className="border p-2 rounded w-1/4 col-2">Price</label>
            <label className="border p-2 rounded w-1/4 col-3">Total</label>
            {isRole === "ADMIN" && (
              <>
                <label className="border p-2 rounded w-1/4 col-2">Edit</label>
              </>
            )}
            {product && product.oil_kg && product.oil_kg.length > 0 && (
              <>
                {product.oil_kg.map((field, index) => (
                  <div key={index}>
                    <input
                      type="text"
                      value={field.time}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.qty}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.price}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.total}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    {isRole === "ADMIN" && (
                      <>
                        <button className="border p-2 rounded w-1/4 col-2 d-inline-block">
                          <SalePOPUP
                            edit_id={field.id}
                            edit_qty={field.qty}
                            edit_price={field.price}
                            edit_type={field.type}
                            edit_total={field.total}
                          />
                        </button>
                      </>
                    )}
                  </div>

                ))}
                <div className="col-md-12 col-12">
                  <label> Total</label>
                  <input
                    type="number"
                    name="oil_kg_total_amount"
                    className="form-control"
                    value={
                      (Array.isArray(product?.oil_kg)
                        ? product.oil_kg.reduce((sum, item) => sum + parseFloat(item?.total || 0), 0).toFixed(2)
                        : 0
                      )
                    }
                    disabled
                    readOnly
                  />
                </div>
              </>
            )}
          </div>
          <div className="col-12 col-md-3 bg-blue-100 rounded">
            <h5 className="font-bold">Oil ltr:- </h5>
            <label className="border p-2 rounded w-1/4 col-3">Time</label>
            <label className="border p-2 rounded w-1/4 col-2">Qty</label>
            <label className="border p-2 rounded w-1/4 col-2">Price</label>
            <label className="border p-2 rounded w-1/4 col-3">Total</label>
            {isRole === "ADMIN" && (
              <>
                <label className="border p-2 rounded w-1/4 col-2">Edit</label>
              </>
            )}
            {product && product.oil_ltr && product.oil_ltr.length > 0 && (
              <>
                {product.oil_ltr.map((field, index) => (
                  <div key={index}>
                    <input
                      type="text"
                      value={field.time}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.qty}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.price}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.total}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    {isRole === "ADMIN" && (
                      <>
                        <button className="border p-2 rounded w-1/4 col-2 d-inline-block">
                          <SalePOPUP
                            edit_id={field.id}
                            edit_qty={field.qty}
                            edit_price={field.price}
                            edit_type={field.type}
                            edit_total={field.total}
                          />
                        </button>
                      </>
                    )}
                  </div>
                ))}

                <div className="col-md-12 col-12">
                  <label> Total</label>
                  <input
                    type="number"
                    name="oil_ltr_total_amount"
                    className="form-control"
                    value={
                      (Array.isArray(product?.oil_ltr)
                        ? product.oil_ltr.reduce((sum, item) => sum + parseFloat(item?.total || 0), 0).toFixed(2)
                        : 0
                      )
                    }
                    disabled
                    readOnly
                  />
                </div>
              </>
            )}
          </div>
          <div className="col-12 col-md-3 bg-blue-100 rounded">
            <h5 className="font-bold">Cake:- </h5>
            <label className="border p-2 rounded w-1/4 col-3">Time</label>
            <label className="border p-2 rounded w-1/4 col-2">Qty</label>
            <label className="border p-2 rounded w-1/4 col-2">Price</label>
            <label className="border p-2 rounded w-1/4 col-3">Total</label>
            {isRole === "ADMIN" && (
              <>
                <label className="border p-2 rounded w-1/4 col-2">Edit</label>
              </>
            )}
            {product && product.cake && product.cake.length > 0 && (
              <>
                {product.cake.map((field, index) => (
                  <div key={index}>
                    <input
                      type="text"
                      value={field.time}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.qty}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.price}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.total}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    {isRole === "ADMIN" && (
                      <>
                        <button className="col-2 d-inline-block">
                          <SalePOPUP
                            edit_id={field.id}
                            edit_qty={field.qty}
                            edit_price={field.price}
                            edit_type={field.type}
                            edit_total={field.total}
                          />
                        </button>
                      </>
                    )}
                  </div>
                ))}
                <div className="col-md-12 col-12">
                  <label> Total</label>
                  <input
                    type="number"
                    name="cake_total_amount"
                    className="form-control"
                    value={
                      (Array.isArray(product?.cake)
                        ? product.cake.reduce((sum, item) => sum + parseFloat(item?.total || 0), 0).toFixed(2)
                        : 0
                      )
                    }
                    disabled
                    readOnly
                  />
                </div>
              </>
            )}
          </div>

          <div className="col-12 col-md-3 bg-blue-100 rounded">
            <h5 className="font-bold">Groundnut:-</h5>
            <label className="border p-2 rounded w-1/4 col-3">Time</label>
            <label className="border p-2 rounded w-1/4 col-2">Qty</label>
            <label className="border p-2 rounded w-1/4 col-2">Price</label>
            <label className="border p-2 rounded w-1/4 col-3">Total</label>
            {isRole === "ADMIN" && (
              <label className="border p-2 rounded w-1/4 col-2">Edit</label>
            )}
            {product && product.groundnut && product.groundnut.length > 0 && (
              <>
                {product.groundnut.map((field, index) => (
                  <div key={index}>
                    <input
                      type="text"
                      value={field.time}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.qty}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.price}
                      className="border p-2 rounded w-1/4 col-2"
                      disabled
                    />
                    <input
                      type="text"
                      value={field.total}
                      className="border p-2 rounded w-1/4 col-3"
                      disabled
                    />
                    {isRole === "ADMIN" && (
                      <button className="col-2 d-inline-block">
                        <SalePOPUP
                          edit_id={field.id}
                          edit_qty={field.qty}
                          edit_price={field.price}
                          edit_type={field.type}
                          edit_total={field.total}
                        />
                      </button>
                    )}
                  </div>
                ))}
                <div className="col-md-12 col-12">
                  <label> Total</label>
                  <input
                    type="number"
                    name="groundnut_total_amount"
                    className="form-control"
                    value={
                      (Array.isArray(product?.groundnut)
                        ? product.groundnut.reduce((sum, item) => sum + parseFloat(item?.total || 0), 0).toFixed(2)
                        : 0
                      )
                    }
                    disabled
                    readOnly
                  />
                </div>
              </>
            )}
          </div>

               <div className="col-12 col-md-12 bg-blue-100 rounded">


            {/* 1L Bottles */}



            <h5 className="font-bold">Oil Bottles</h5>
            <label className="border p-2 rounded w-1/4 col-2">Ltr </label>
            <label className="border p-2 rounded w-1/4 col-2">Time</label>
            <label className="border p-2 rounded w-1/4 col-2">Qty</label>
            <label className="border p-2 rounded w-1/4 col-2">Price</label>
            <label className="border p-2 rounded w-1/4 col-2">Total</label>

            {isRole === "ADMIN" && (
              <>
                <label className="border p-2 rounded w-1/4 col-2">Edit</label>
              </>
            )}


            {product?.oil_bottle_1l?.map((field, index) => (
              <>
                <div key={`1l-${index}`} className="row g-2 mb-2 align-items-center">
                  <label className="border p-2 rounded w-1/4 col-2">1L </label>

                  <input type="text" value={field.time} className="border p-2 rounded w-1/4 col-2" disabled />


                  <input type="text" value={field.qty} className="border p-2 rounded w-1/4 col-2" disabled />

                  <input type="text" value={field.price} className="border p-2 rounded w-1/4 col-2" disabled />

                  <input type="text" value={field.total} className="border p-2 rounded w-1/4 col-2" disabled />

                  {isRole === "ADMIN" && (
                    <button className="border p-2 rounded w-1/4 col-2 d-inline-block">
                      <SalePOPUP
                        edit_id={field.id}
                        edit_qty={field.qty}
                        edit_price={field.price}
                        edit_type={field.type || 'oil_bottle_1l'}
                        edit_total={field.total}
                      />
                    </button>
                  )}

                </div>
              </>
            ))}

            {/* 5L Bottles */}
            {product?.oil_bottle_5l?.map((field, index) => (
              <>

                <div key={`5l-${index}`} className="row g-2 mb-2 align-items-center">

                  <label className="border p-2 rounded w-1/4 col-2">5L </label>

                  <input type="text" value={field.time} className="border p-2 rounded w-1/4 col-2" disabled />

                  <input type="text" value={field.qty} className="border p-2 rounded w-1/4 col-2" disabled />

                  <input type="text" value={field.price} className="border p-2 rounded w-1/4 col-2" disabled />

                  <input type="text" value={field.total} className="border p-2 rounded w-1/4 col-2" disabled />

                  {isRole === "ADMIN" && (
                    <button className="border p-2 rounded w-1/4 col-2 d-inline-block">
                      <SalePOPUP
                        edit_id={field.id}
                        edit_qty={field.qty}
                        edit_price={field.price}
                        edit_type={field.type || 'oil_bottle_5l'}
                        edit_total={field.total}
                      />
                    </button>
                  )}
                </div>
              </>
            ))}
            {/* 15L Bottles */}
            {product?.oil_bottle_15l?.map((field, index) => (
              <>

                <div key={`15l-${index}`} className="row g-2 mb-2 align-items-center">
                  <label className="border p-2 rounded w-1/4 col-2">15L </label>
                  <input type="text" value={field.time} className="border p-2 rounded w-1/4 col-2" disabled />


                  <input type="text" value={field.qty} className="border p-2 rounded w-1/4 col-2" disabled />

                  <input type="text" value={field.price} className="border p-2 rounded w-1/4 col-2" disabled />

                  <input type="text" value={field.total} className="border p-2 rounded w-1/4 col-2" disabled />

                  {isRole === "ADMIN" && (
                    <button className="border p-2 rounded w-1/4 col-2 d-inline-block">
                      <SalePOPUP
                        edit_id={field.id}
                        edit_qty={field.qty}
                        edit_price={field.price}
                        edit_type={field.type || 'oil_bottle_15l'}
                        edit_total={field.total}
                      />
                    </button>
                  )}
                </div>

              </>

            ))}
            <div className="col-md-12 col-12">
              <label> Total Bottles</label>
              <input
                type="number"
                name="total_all_bottles"
                className="form-control"
                value={(() => {
                  const total =
                    (Array.isArray(product?.oil_bottle_1l) ?
                      product.oil_bottle_1l.reduce((sum, item) => sum + parseFloat(item?.total || 0), 0) : 0) +
                    (Array.isArray(product?.oil_bottle_5l) ?
                      product.oil_bottle_5l.reduce((sum, item) => sum + parseFloat(item?.total || 0), 0) : 0) +
                    (Array.isArray(product?.oil_bottle_15l) ?
                      product.oil_bottle_15l.reduce((sum, item) => sum + parseFloat(item?.total || 0), 0) : 0);

                  return total.toFixed(2);
                })()} disabled readOnly />
            </div>
          </div>
        </div>
        <div className="row">

          <div className="col-md-12 col-12">
            <label>Total Amount</label>
            <input
              type="number"
              name="grandTotal"
              className="form-control fw-bold"
              placeholder="Total"
              value={
                (product?.oil_total_amount || 0) +
                (product?.cake_total_amount || 0) +
                (product?.groundnut_total_amount || 0)
              }
              disabled
            />
          </div>


        </div>
      </div>

      <div className="product-form all-bottom-fild">
        <div className="row">
          <div className="col-12 col-md-4 bg-green-100 rounded">
            <h5 className="font-bold">Credit</h5>
            <div className="mb-2">
              <CreditLocalPOPUP
                savedData={savedData}
                onAdd={(p) => {
                  setFields([
                    ...fields,
                    { amount: p.amount || "", name: p.name || "" },
                  ]);
                }}
              />
            </div>

            {fields.map((field, index) => (
              <div key={index}>
                <input
                  type="number"
                  placeholder="Amount"
                  value={field.amount}
                  onChange={(e) => {
                    const newFields = [...fields];
                    newFields[index].amount = e.target.value;
                    setFields(newFields);
                  }}
                  className="border p-2 rounded col-3"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={field.name}
                  onChange={(e) => {
                    const newFields = [...fields];
                    newFields[index].name = e.target.value;
                    setFields(newFields);
                  }}
                  className="border p-2 rounded col-8"
                  list="name-suggestions"
                  required="required"
                />
                {isRole === "ADMIN" && fields.length > 0 && (
                  <button
                    type="button"
                    onClick={() => removeCredit(index)}
                    className="p-2 bg-red-500 text-white rounded col-1"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            <datalist id="name-suggestions">
              {savedData.map((item, index) => (
                <option key={index} value={item.name} />
              ))}
            </datalist>
            <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
              Total Credit Amount: {getInputTotal()}
            </div>
          </div>

          {/* Dynamic Input Fields for Minesh (Subtracting) */}
          <div className="col-12 col-md-4 bg-red-100 rounded">
            <h5 className="font-bold">Deposit Amount</h5>
            <div className="mb-2">
              <DepositPOPUP
                banks={banksavedData}
                savedData={savedData}
                onAdd={(payload) => {
                  const next = [
                    ...mineshFields,
                    {
                      amount: payload.amount || "",
                      name: payload.name || "",
                      mode: payload.mode || "Cash",
                      bank_show: payload.bank_show || false,
                      bank_name: payload.bank_name || "",
                    },
                  ];
                  setMineshFields(next);
                }}
              />
            </div>
            {mineshFields.map((field, index) => (
              <div key={index}>
                <input
                  type="number"
                  placeholder="Amount to Subtract"
                  value={field.amount}
                  onChange={(e) => {
                    const newFields = [...mineshFields];
                    newFields[index].amount = e.target.value;
                    setMineshFields(newFields);
                  }}
                  className="border p-2 rounded col-3 col-md-3"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={field.name}
                  onChange={(e) => {
                    const newFields = [...mineshFields];
                    newFields[index].name = e.target.value;
                    setMineshFields(newFields);
                  }}
                  className="border p-2 rounded col-8 col-md-5"
                  list="name-suggestions"
                  required="required"
                />
                <select
                  value={field.mode}
                  onChange={(e) => {
                    const newFields = [...mineshFields];
                    newFields[index].mode = e.target.value;
                    setMineshFields(newFields);
                    if (e.target.value == "Cash") {
                      newFields[index].bank_show = false;
                      newFields[index].bank_name = "";
                    } else {
                      newFields[index].bank_show = true;
                    }
                    setMineshFields(newFields);
                  }}
                  className="border p-2 rounded col-8 col-md-3"
                  required="required"
                >
                  <option value="Cash">Cash</option>
                  <option value="Scan">Scan</option>
                  <option value="Swipe">Swipe</option>
                  <option value="Bank">Bank</option>
                </select>
                <input
                  type="text"
                  placeholder="Bank Name"
                  value={field.bank_name}
                  onChange={(e) => {
                    const newFields = [...mineshFields];
                    newFields[index].bank_name = e.target.value;
                    setMineshFields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-8 col-md-11"
                  required={field.bank_show}
                  list="bank_name-suggestions"
                  style={{ display: field.bank_show ? "inline-block" : "none" }}
                />
                {isRole === "ADMIN" && mineshFields.length > 0 && (
                  <button
                    type="button"
                    onClick={() => removeDeposit(index)}
                    className="p-2 bg-red-500 text-white rounded col-1"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            <datalist id="bank_name-suggestions">
              {banksavedData.map((item, index) => (
                <option key={index} value={item.name} />
              ))}
            </datalist>
            <div className="mt-4 p-2 bg-red-200 text-black font-bold rounded">
              Total Deposit Amount : {getMineshTotal()}
            </div>
          </div>
          {/* Dynamic Extra (Subtracting) */}
          <div className="col-12 col-md-4 bg-blue-100 rounded">
            <h5 className="font-bold">Expinese</h5>
            <div className="mb-2">
              <ExpensePOPUP
                expineseList={expineseData}
                onAdd={(p) => {
                  setExtraFields([
                    ...extraFields,
                    { amount: p.amount || "", name: p.name || "" },
                  ]);
                }}
              />
            </div>
            {extraFields.map((field, index) => (
              <div key={index}>
                <input
                  type="number"
                  placeholder="Amount"
                  value={field.amount}
                  onChange={(e) => {
                    const newFields = [...extraFields];
                    newFields[index].amount = e.target.value;
                    setExtraFields(newFields);
                  }}
                  className="border p-2 rounded col-3"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={field.name}
                  onChange={(e) => {
                    const newFields = [...extraFields];
                    newFields[index].name = e.target.value;
                    setExtraFields(newFields);
                  }}
                  className="border p-2 rounded col-8"
                  required="required"
                  list="Expinese-suggestions"
                />
                {isRole === "ADMIN" && extraFields.length > 0 && (
                  <button
                    type="button"
                    onClick={() => removeExpense(index)}
                    className="p-2 bg-red-500 text-white rounded col-1"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            <datalist id="Expinese-suggestions">
              {expineseData.map((item, index) => (
                <option key={index} value={item.name} />
              ))}
            </datalist>
            <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
              Total Extra Amount: {getExtraTotal()}
            </div>
          </div>

          <div className="col-12 col-md-6 bg-blue-100 rounded">
            <h5 className="font-bold">Card</h5>
            <div className="mb-2">
              <CardPOPUP
                banks={banksavedData}
                onAdd={(p) => {
                  setCardFields([
                    ...cardFields,
                    {
                      amount: p.amount || "",
                      name: p.name || "",
                      time: p.time || "",
                      mode: p.mode || "Scan",
                      bank_name: p.bank_name || "",
                    },
                  ]);
                }}
              />
            </div>
            {cardFields.map((field, index) => (
              <div key={index}>
                <input
                  type="number"
                  placeholder="Amount"
                  value={field.amount}
                  onChange={(e) => {
                    const newFields = [...cardFields];
                    newFields[index].amount = e.target.value;
                    setCardFields(newFields);
                  }}
                  className="border p-2 rounded col-3 col-md-2"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={field.name}
                  onChange={(e) => {
                    const newFields = [...cardFields];
                    newFields[index].name = e.target.value;
                    setCardFields(newFields);
                  }}
                  className="border p-2 rounded col-5 col-md-2"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Time"
                  value={field.time}
                  onChange={(e) => {
                    const newFields = [...cardFields];
                    newFields[index].time = e.target.value;
                    setCardFields(newFields);
                  }}
                  className="border p-2 rounded col-3 col-md-2"
                  required="required"
                />
                <select
                  value={field.mode}
                  onChange={(e) => {
                    const newFields = [...cardFields];
                    newFields[index].mode = e.target.value;
                    setCardFields(newFields);
                  }}
                  className="border p-2 rounded col-8 col-md-2"
                  required="required"
                >
                  <option value="Scan">Scan</option>
                  <option value="Swipe">Swipe</option>
                </select>
                <input
                  type="text"
                  placeholder="Bank Name"
                  value={field.bank_name}
                  onChange={(e) => {
                    const newFields = [...cardFields];
                    newFields[index].bank_name = e.target.value;
                    setCardFields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-8 col-md-3"
                  required="required"
                  list="bank_name-suggestions"
                />
                {isRole === "ADMIN" && cardFields.length > 0 && (
                  <button
                    type="button"
                    onClick={() => removeCard(index)}
                    className="p-2 bg-red-500 text-white rounded col-1"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
              Total Card Amount: {getCardTotal()}
            </div>
          </div>

          <div className="col-12 col-md-3 bg-blue-100 rounded">
            <h5 className="font-bold"> Payment Outside :- </h5>
            <div className="mb-2">
              <CustomOutsidePOPUP
                loanNames={Loancustomerssuggestions}
                onAdd={(p) => {
                  setCustomTrFields([
                    ...customTrFields,
                    { name: p.name || "", amount: p.amount || "" },
                  ]);
                }}
              />
            </div>
            {customTrFields.map((field, index) => (
              <div key={index}>
                <input
                  type="number"
                  placeholder="Amount"
                  value={field.amount}
                  onChange={(e) => {
                    const newFields = [...customTrFields];
                    newFields[index].amount = e.target.value;
                    setCustomTrFields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-3"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={field.name}
                  onChange={(e) => {
                    const newFields = [...customTrFields];
                    newFields[index].name = e.target.value;
                    setCustomTrFields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-8"
                  required="required"
                  list="Loancustomerssuggestions-suggestions"
                />
                {isRole === "ADMIN" && customTrFields.length > 0 && (
                  <button
                    type="button"
                    onClick={() => removeOutside(index)}
                    className="p-2 bg-red-500 text-white rounded col-1"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            <datalist id="Loancustomerssuggestions-suggestions">
              {Loancustomerssuggestions.map((item, index) => (
                <option key={index} value={item.name} />
              ))}
            </datalist>
            <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
              Total Custom Tr Amount: {getCustomTotal()}
            </div>
          </div>
          <div className="col-12 col-md-3 bg-blue-100 rounded">
            <h5 className="font-bold">Payment Inside:- </h5>
            <div className="mb-2">
              <CustomInsidePOPUP
                loanNames={Loancustomerssuggestions}
                onAdd={(p) => {
                  setAnotherCustomFields([
                    ...anotherCustomFields,
                    { name: p.name || "", amount: p.amount || "" },
                  ]);
                }}
              />
            </div>
            {anotherCustomFields.map((field, index) => (
              <div key={index}>
                <input
                  type="number"
                  placeholder="Amount"
                  value={field.amount}
                  onChange={(e) => {
                    const newFields = [...anotherCustomFields];
                    newFields[index].amount = e.target.value;
                    setAnotherCustomFields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-3"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={field.name}
                  onChange={(e) => {
                    const newFields = [...anotherCustomFields];
                    newFields[index].name = e.target.value;
                    setAnotherCustomFields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-8"
                  required="required"
                  list="Loancustomerssuggestions-suggestions"
                />
                {isRole === "ADMIN" && anotherCustomFields.length > 0 && (
                  <button
                    type="button"
                    onClick={() => removeInside(index)}
                    className="p-2 bg-red-500 text-white rounded col-1"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
              Total Payment Inside Amount: {getAnotherCustomTotal()}
            </div>
          </div>
          <div className="col-12 col-md-6 bg-blue-100 rounded">
            <h5 className="font-bold">Bank Entry:- </h5>
            <div className="mb-2">
              <BankEntryPOPUP
                banks={banksavedData}
                loanNames={Loancustomerssuggestions}
                onAdd={(p) => {
                  setBankDepositfields([
                    ...BankDepositfields,
                    {
                      amount: p.amount || "",
                      bank_name: p.bank_name || "",
                      name: p.name || "",
                      type: p.type || "Cash Deposit",
                    },
                  ]);
                }}
              />
            </div>
            {BankDepositfields.map((field, index) => (
              <div key={index}>
                <input
                  type="number"
                  placeholder="Amount"
                  value={field.amount}
                  onChange={(e) => {
                    const newFields = [...BankDepositfields];
                    newFields[index].amount = e.target.value;
                    setBankDepositfields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-2"
                  required="required"
                />
                <input
                  type="text"
                  placeholder="Bank Name"
                  value={field.bank_name}
                  onChange={(e) => {
                    const newFields = [...BankDepositfields];
                    newFields[index].bank_name = e.target.value;
                    setBankDepositfields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-3"
                  required="required"
                  list="bank_name-suggestions"
                />
                <input
                  type="text"
                  placeholder="Name"
                  value={field.name}
                  onChange={(e) => {
                    const newFields = [...BankDepositfields];
                    newFields[index].name = e.target.value;
                    setBankDepositfields(newFields);
                  }}
                  className="border p-2 rounded w-1/2 col-3"
                  required="required"
                  list="Loancustomerssuggestions-suggestions"
                />
                <select
                  value={field.type}
                  onChange={(e) => {
                    const newFields = [...BankDepositfields];
                    newFields[index].type = e.target.value;
                    setBankDepositfields(newFields);
                  }}
                  className="border p-2 rounded col-3"
                  required="required"
                >
                  <option value="Cash Deposit">Cash Deposit</option>
                  <option value="RTGS IN">RTGS IN</option>
                  <option value="RTGS OUT">RTGS OUT</option>
                  <option value="Charges">Charges</option>
                  <option value="Payment">Payment</option>
                </select>

                {isRole === "ADMIN" && BankDepositfields.length > 0 && (
                  <button
                    type="button"
                    onClick={() => removeBankEntry(index)}
                    className="p-2 bg-red-500 text-white rounded col-1"
                  >
                    -
                  </button>
                )}
              </div>
            ))}
            {/* <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
                Total Bank Entry Amount: {getBankDepositfields()}
              </div> */}
          </div>
          <div className="col-12 col-md-6 bg-blue-100 rounded">
            <h5 className="font-bold">Bank Statement:- </h5>
            {BankDepositChargefields &&
              BankDepositChargefields.data &&
              BankDepositChargefields.data.length > 0 && (
                <>
                  <label className="border p-2 rounded w-1/4 col-3">
                    Bank Name
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    Deposite
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    Charges
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    Previous Total
                  </label>

                  {BankDepositChargefields.data.map((field, index) => (
                    <div key={index}>
                      <input
                        type="text"
                        placeholder="Bank Name"
                        value={field.bank_name}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                      <input
                        type="text"
                        placeholder="Deposite"
                        value={field.deposite}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                      <input
                        type="text"
                        placeholder="Charges"
                        value={field.charges}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                      <input
                        type="text"
                        placeholder="Total"
                        value={field.total}
                        className="border p-2 rounded w-1/4 col-3"
                        disabled
                      />
                    </div>
                  ))}

                  <label className="border p-2 rounded w-1/4 col-3">
                    &nbsp;
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    &nbsp;
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    Deposite
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    {BankDepositChargefields.all_bank_total_deposite}
                  </label>

                  <label className="border p-2 rounded w-1/4 col-3">
                    &nbsp;
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    &nbsp;
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    Charges
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    {BankDepositChargefields.all_bank_total_charges}
                  </label>

                  <label className="border p-2 rounded w-1/4 col-3">
                    &nbsp;
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    &nbsp;
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    Total
                  </label>
                  <label className="border p-2 rounded w-1/4 col-3">
                    {BankDepositChargefields.all_bank_bank_total}
                  </label>
                </>
              )}
          </div>
          <div className="col-12 bg-blue-100 rounded">
            Previous day Total: {previous_day_total}
          </div>
          <div className="col-12 bg-blue-100 rounded">
            Current day Total: {Current_day_total()}
          </div>
          <div className="col-12 bg-blue-100 rounded">
            Net Total: {Net_total()}
          </div>
          <div className="col-12 bg-blue-100 rounded">
            Final Total: {Final_total()}
          </div>

          {isLoggedIn && (
            <div className="col-md-12 col-12">
              {/* <button className="btn bt-form" type="submit" disabled={loading}>
                  {loading ? "Adding..." : "Add Product"}
                </button> */}
              <button
                className="btn bt-form"
                onClick={handleSubmit}
                type="submit"
                disabled={loading}
              >
                {loading ? "Adding..." : "Add Product"}
              </button>
              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}
            </div>
          )}
        </div>
      </div>
      {/* </form> */}
    </>
  );
};
export default AddProductForm;
